import { proxy } from 'valtio';
import { StepIndexerState } from 'hooks/useStepIndexer';

export const createOnlineMeetingStepIndexer = proxy<StepIndexerState>({
  stepIndex: 0,
  previousStep: 0,
});
